document.addEventListener('DOMContentLoaded', function () {
  class YGBuyItNow extends HTMLElement {
    constructor() {
        super()
        this.init()
    }
    init() {
        // 这里放置初始化逻辑
        let _this = this
        let $button = _this.querySelector('.yg-buy-it-now-button')
        if($button) {
          $button.addEventListener('click', () => _this.buttonClick())
        }
    }
    buttonClick() {
        let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options');
        if(buyBtn) {
          buyBtn.click();
        } else {
          console.log('buyBtn not exist');
        }
        
    }
}
if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
}
});